import http from "../http-common";

class SupplierDataService {
  getAll() {
    return http.get("/supplier");
  }

  get(id) {
    return http.get(`/supplier/${id}`);
  }

  getByProject(id) {
    return http.get(`/supplier/getByProject/${id}`);
  }

  create(data) {
    return http.post("/supplier", data);
  }

  createBulk(data) {
    return http.post("/supplier/bulk", data);
  }

  update(id, data) {
    return http.put(`/supplier/${id}`, data);
  }

  delete(id) {
    return http.delete(`/supplier/${id}`,);
  }

  deleteAll() {
    return http.delete(`/supplier`, );
  }

  findByTitle(title) {
    return http.get(`/supplier?title=${title}`,);
  }

  cloneProject(data) {
    return http.post("/supplier/clone", data);
  }

}

export default new SupplierDataService();